export const environment = {
  apiUrl: 'https://climars-hml.pub.hsm.rs.gov.br/climars/api/v1/',
  production: false,
};
